import axios from 'axios'
import appConfig from 'Configs/app.config'
import {PERSIST_STORE_NAME} from 'Constants/app.constant'
import {REQUEST_HEADER_AUTH_KEY, TOKEN_TYPE} from "../Constants/api.constant";
import deepParseJson from 'Utils/deepParseJson'
import {setInSecure} from "../Store/auth/authSlice";
import store from "../Store";

const unauthorizedCode = [401]

const BaseService = axios.create({
  timeout: 60000,
  baseURL: appConfig.apiPrefix,
})

let hasLocalStorage = true
try {
  localStorage.getItem('a')
} catch {
  hasLocalStorage = false
}

BaseService.interceptors.request.use(config => {
  const rawPersistData = hasLocalStorage ? localStorage.getItem(PERSIST_STORE_NAME) : {}

  const persistData = deepParseJson(rawPersistData)
  // Use liquidToken for API auth, not the encrypted session
  const token = persistData?.auth?.liquidToken

  if (token && config.headers[REQUEST_HEADER_AUTH_KEY] !== '') {
    config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${token}`
  }

  return config
}, error => {
  return Promise.reject(error)
})

BaseService.interceptors.response.use(
  response => response,
  error => {

    const {response} = error

    if (response && unauthorizedCode.includes(response.status)) {
      store.dispatch(setInSecure())
    }

    return Promise.reject(error)
  }
)

export default BaseService